

































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import topTitle from "@/components/faceCoupon/topTitle.vue";
import topStep from "@/components/faceCoupon/topStep.vue";

const faceCouponSureModule = namespace("faceCoupon");
@Component({
  components: {
    topStep,
    topTitle
  }
})
export default class FaceCouponsSure extends Vue {
  @faceCouponSureModule.State("detailData") detailData!: any;
  // @faceCouponSureModule.State("faceCouponList") list!: any;
  // @faceCouponSureModule.State("faceCouponCancelPage") pages!: any;
  @faceCouponSureModule.State("faceMoreList") faceMoreList!: any;
  @faceCouponSureModule.State("faceCouponLoading")
  faceCouponLoading!: boolean;
  titleName: string = "面对面赠券";
  stepsArry = [
    { num: 1, name: "查询会员", class: "active" },
    { num: 2, name: "赠券", class: "active" },
    { num: 3, name: "完成", class: "" }
  ]; /* 步骤 */
  count: number = 0;
  finished: boolean = false;
  loading: boolean = false;
  defaultImg :any = require("@/image/default.png");
  list:any =[]
  pages:any ={
    pageNum:1,
    pageSize:10,
    totalPage:0,
  }
  
  get loadingShow() {
    return this.loading;
  }
  set loadingShow(newVal) {
    this.loading = this.faceCouponLoading;
  }
  mounted() {
    this.getDetails();
  }
  getDetails() {
    this.$store.dispatch("faceCoupon/getMemberDetailData", {
      searchText: this.$route.query.val,
      searchType: this.$route.query.type
    });
  }
  getFaceCouponList() {
    console.log(this.pages.total)
    console.log('123',this.detailData)
    if (this.pages.total > 0 && this.pages.total === this.list.length) {
      this.finished = true;
    }
    this.$store.dispatch("faceCoupon/getFaceCouponList", {
      pageNum: this.pages.pageNum,
      pageSize: this.pages.pageSize,
      couponInstanceCid:this.detailData.member.customerCid,
      couponBusinessEntityId:this.$global.tenantId,
      parentTenantId:this.$global.parentBusinessEntityId ? this.$global.parentBusinessEntityId : this.$global.tenantId,
      parentTenantType:this.$global.parentBusinessEntityTypeId ? this.$global.parentBusinessEntityTypeId : this.$global.tenantType,
    })
      .then(res => {
        this.loading = false;
        console.log('debugger')
        if (res.success) {
          this.pages.totalPage = res.success.data.pages;
          if(!res.success.data.list){
            this.finished = true;
            return;
          }
          this.list = [...this.list, ...res.success.data.list];
          console.log('1231321',this.list);
          this.list.map((item: any) => {
            item.stepNum = 0;
            if(item.couponEffectiveSwitch == 0){
              item.couponEffectiveStartTime = this.$format(
                item.couponEffectiveStartTime,
                "YYYY.MM.DD"
              );
              item.couponEffectiveEndTime = this.$format(
                item.couponEffectiveEndTime,
                "YYYY.MM.DD"
              );
              return false;
            }
            if(item.couponEffectiveSwitch == 2){
              item.couponEffectiveStartTime = this.$format(
                item.couponGetStartTime,
                "YYYY.MM.DD"
              );
              item.couponEffectiveEndTime = this.$format(
                item.couponGetEndTime,
                "YYYY.MM.DD"
              );
              return false;
            }
            
          });
          this.pages.pageNum++;
          console.log(this.pages.totalPage)
          if (this.pages.pageNum > this.pages.totalPage) {
            this.finished = true;
          }
          console.log(this.list);
        } else {
          this.finished = true;
        }
      });
  }
  onLoadList() {
    let self=this;
    setTimeout(() => {
      self.getFaceCouponList()
    }, 1000);
    
    // if(this.list){
      // this.getFaceCouponList(this.pages.pageNum + 1);
    // }
  }
  steperPlus(item: any,index :any) {
    if (this.count < 5) {
      this.count++;
      this.list[index].stepNum ++;
      return false;
    }
    (this as any).$dialog.alert({ message: "最多可选取5张优惠券" });
  }
  steperMinus(item: any,index :any) {
    if (this.count < 1) {
      this.count = 0;
      return false;
    }
    if(this.list[index].stepNum < 1){
      this.list[index].stepNum = 0
      return false;
    }
    this.count--;
    this.list[index].stepNum --;
  }
  sureCoupon() {
    if (this.count < 1) {
      (this as any).$dialog.alert({ message: "请选择要赠送的优惠券" });
      return false;
    }
    let getCoupons = []
    for(let i =0; i < this.list.length; i++){
      if(this.list[i].stepNum !== 0){
        getCoupons.push({
          couponBatchId:this.list[i].couponBatchId,
          couponId:this.list[i].couponId,
          num:this.list[i].stepNum,
        })
      }
    }
    let meber = this.detailData && this.detailData.member ? this.detailData.member : {};
    console.log(meber,getCoupons)
    this.$store
      .dispatch("faceCoupon/faceCouponGetMore", {
        couponInstanceCid:this.detailData.member.customerCid, //会员Id
        couponInstanceMobile: this.detailData.member.memberMobile,
        couponActivityId: this.list[0].couponActivityId,
        couponInstanceType:this.detailData.member.memberMobile ? 2 : 1,   //领取方式
        getCoupons:getCoupons,
        parentTenantId: this.$global.parentBusinessEntityId ? this.$global.parentBusinessEntityId : this.$global.tenantId,
        parentTenantType: this.$global.parentBusinessEntityTypeId ?this.$global.parentBusinessEntityTypeId :this.$global.tenantType
      })
  }
}
